<template>
    <div v-loading="loading">
        <div class="search-ctn" style="padding: 0 10px; margin-bottom: 10px">
            <div class="show-info">仓库名称：{{ spaceInfo.WarehouseName }}</div>
            <div class="show-info">仓位编号：{{ spaceInfo.SpaceCode }}</div>
            <div class="show-info">存放的商品种类：{{ cateCount }}</div>
            <div class="show-info">商品总数量：{{ allNum }}</div>
        </div>
        <div class="no-data" v-if="noData">该仓位暂无货物</div>
        <div v-else style="border-bottom: 1px solid #ebeef5">
            <div class="section-title">商品明细</div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 25%">汽配编码</div>
                    <div class="div-table-cell" style="width: 20%">互换码</div>
                    <div class="div-table-cell" style="width: 30%">汽配名称</div>
                    <div class="div-table-cell" style="width: 10%">数量</div>
                    <div class="div-table-cell" style="width: 10%">单位</div>
                    <div class="div-table-cell inventory-title" style="width: 15%">
                        <div>库存数据</div>
                        <div>
                            <div>待出库</div>
                            <div>库存</div>
                            <div>留余</div>
                        </div>
                    </div>
                </div>
                <div class="table-main">
                    <div :key="index" class="div-table-row table-item" v-for="(item, index) in dataList">
                        <!--        编码            -->
                        <div class="div-table-cell" style="width: 25%">
                            <el-tooltip effect="dark" :content="item.APCode" placement="top">
                                <span>{{ item.APCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        互换码            -->
                        <div class="div-table-cell" style="width: 20%">
                            <el-tooltip effect="dark" :content="item.GoodCode" placement="top">
                                <span>{{ item.GoodCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        汽配名称            -->
                        <div class="div-table-cell" style="width: 30%; padding-right: 6px">
                            <el-tooltip effect="dark" :content="item.GoodName" placement="top">
                                <span>{{ item.GoodName }}</span>
                            </el-tooltip>
                        </div>
                        <!--        数量            -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
                                <span>{{ item.Count }}</span>
                            </el-tooltip>
                        </div>
                        <!--        单位         -->
                        <div class="div-table-cell" style="width: 10%">{{ item.Unit }}</div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" :content="item.WaitingOutWarehouseQuantity.toString()" placement="top">
                                <span>{{ item.WaitingOutWarehouseQuantity }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" :content="item.Inventory.toString()" placement="top">
                                <span>{{ item.Inventory }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%" :class="{ 'color-red': item.Inventory - item.WaitingOutWarehouseQuantity <= 0 }">
                            <el-tooltip effect="dark" :content="(item.Inventory - item.WaitingOutWarehouseQuantity).toString()" placement="top">
                                <span>{{ item.Inventory - item.WaitingOutWarehouseQuantity }}</span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="div-table-row table-item">
                        <div class="div-table-cell" style="width: 25%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 30%"></div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                <span>{{ allNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell inventory-title" style="width: 15%">
                            <span class="color-red" v-if="lack">库存紧张</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['ShelfSpaceId', 'WarehouseId'],
    components: {},
    data() {
        return {
            loading: true,
            noData: false,
            lack: false,
            allNum: '',
            cateCount:0,
            dataList: [],
            searchData: {
                ShelfSpaceId: this.ShelfSpaceId,
                WarehouseId: this.WarehouseId
            },
            spaceInfo: {
                WarehouseName: '',
                SpaceCode: ''
            }
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetGoodsLocations',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    
                    if (!res.data || res.data.DetailList.length == 0) {
                        this.noData = true;
                        this.loading = false;
                        return;
                    }
                    let DetailList = res.data.DetailList;
                    let _lack = false; // 库存是否紧缺
                    let _allNum = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        if (DetailList[i].Inventory - DetailList[i].WaitingOutWarehouseQuantity <= 0) {
                            _lack = true;
                        }
                    }
                    this.spaceInfo = res.data.SpaceData;
                    this.cateCount =DetailList.length;
                    this.allNum = _allNum;
                    this.lack = _lack;
                    this.dataList = DetailList;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    position: relative;
    &:after {
        position: absolute;
        top: 0;
        left: 0;
        border-left: 1px solid #ebeef5;
        content: '';
        height: 100%;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.business-content-main {
    padding-right: 80px;
}
.table-main {
    position: relative; 
    max-height: 55vh;
    overflow: auto;
}
.table-main::-webkit-scrollbar {
    display: none;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 40px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
.show-info {
    flex-shrink: 0;
    margin: 0 10px;
    height: 32px;
    line-height: 32px;
}
</style>
